import { atom } from "jotai";
import { selectedSkillIdAtom } from "../skill/atoms";
import { selectedTrainingResourceIdAtom } from "../resource/atoms";

// Course builder state lives in stores/useCourseBuilderStore. The shared
// undo/redo stack in BuilderActionContext is still jotai, so the page mirrors
// the open course's id into this atom (like selectedSkillIdAtom).
export const selectedCourseIdAtom = atom<number | undefined>(undefined);

export const selectedContentIdsAtom = atom((get) => ({
  courseId: get(selectedCourseIdAtom),
  skillId: get(selectedSkillIdAtom),
  trainingResourceId: get(selectedTrainingResourceIdAtom),
}));
